// link to user agreements report from
// fetch data from User Agreements collection
// do graph

import React, { useEffect, useState } from 'react';
import { getAllSignedAgreements, setCurrentPage, revertFlag } from 'store/actions';
import { connect } from 'react-redux';
import AgreementList from './AgreementList';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import withStyles from '@material-ui/core/es/styles/withStyles';
import { AGREEMENT_REPORT_THEME } from './AgreementMuiTheme';
import { MuiThemeProvider, Tab, Tabs, Typography } from '@material-ui/core';
import AgreementReportStyle from './AgreementReportStyle';
import Auxiliary from 'hoc/Auxiliary';
import { AGREEMENT_REPORT } from 'constants/Constants';
import CustomHeader from 'components/CustomHeader/CustomHeader';
import Spinner from 'components/UI/Spinner/Spinner';

const AgreementReport = (props) => {
    const { classes, getAllSignedAgreements, isUserAgreementSignedLoaded, setCurrentPage } = props;

    useEffect(() => {
        setCurrentPage(AGREEMENT_REPORT);
    }, [setCurrentPage]);

    useEffect(() => {
        const accountId = props.match.params.id;
        getAllSignedAgreements(accountId);
    }, [getAllSignedAgreements]);

    const [value, setValue] = useState(0);

    const TabContainer = (props) => {
        return <Typography component="div">{props.children}</Typography>;
    };

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Auxiliary>
            <CustomHeader title="TERMS OF USE REPORT" />
            <div className={classes.reportContainer}>
                <MuiThemeProvider theme={AGREEMENT_REPORT_THEME}>
                    <Paper className={classes.paperRoot} elevation={1}>
                        {isUserAgreementSignedLoaded ? (
                            <Grid container>
                                <Grid item xs={12}>
                                    <label id={'pageTitle'} className={classes.titleBar}>
                                        {'TERMS OF USE'}
                                    </label>
                                </Grid>
                                <Grid item xs={12}>
                                    <Tabs
                                        value={value}
                                        onChange={handleChange}
                                        indicatorColor="primary"
                                        textColor="primary"
                                        centered
                                    >
                                        <Tab label="ACCEPTED" />
                                        <Tab label="NOT ACCEPTED" />
                                    </Tabs>
                                </Grid>
                                <Grid item xs={12}>
                                    <Paper className={classes.paperList}>
                                        {value === 0 && (
                                            <TabContainer>
                                                <AgreementList loadAccepted={true} />
                                            </TabContainer>
                                        )}
                                        {value === 1 && (
                                            <TabContainer>
                                                <AgreementList loadAccepted={false} />
                                            </TabContainer>
                                        )}
                                    </Paper>
                                </Grid>
                            </Grid>
                        ) : (
                            <Spinner />
                        )}
                    </Paper>
                </MuiThemeProvider>
            </div>
        </Auxiliary>
    );
};

const mapStateToProps = (state) => ({
    isUserAgreementSignedLoaded: state.termsAndConditions.isUserAgreementSignedLoaded
});

export default connect(mapStateToProps, { getAllSignedAgreements, revertFlag, setCurrentPage })(
    withStyles(AgreementReportStyle)(AgreementReport)
);
